import Color from "../../layouts/Color";
import { Box, Container, Grid, Step, StepButton, StepContent, Stepper, Typography } from "@mui/material";
import { ListGuide } from "./ListGuide";
import { makeStyles } from "@mui/styles";
import { useState } from "react";
import clsx from "clsx";

const box = {
    display: 'flex',
    overflow: 'hidden'
}

const container = {
    mt: 5,
    mb: 7,
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
}

const title = {
    mb: 6,
    color: Color.Dangerous
}

const boxStep = {
    mb: 5,
    display: 'flex',
    justifyContent: 'space-evenly',
    fontFamily: "'Asap', normal",
}

const boxImage = { 
    border: '1px solid ' + Color.Blur, 
    p: 2, 
    borderRadius: '6px' 
}

const content = { 
    textAlign: 'left',
    fontFamily: "'Asap', normal",
}

export default function MainGuide() {
    const classes = useStyles();
    const [selected, setSelected] = useState(0);
    const [step, setStep] = useState(0);

    return (
        <Box component="section" sx={box}>
            <Container sx={container}>
                <Typography variant="h4" sx={title}>User guide for customer app</Typography>
                <Container maxWidth="lg">
                    <Box sx={boxStep}>
                        {ListGuide.map((p, index) => {
                            return (
                                <Box
                                    key={index}
                                    className={clsx(classes.topic, { [classes.topicSelected]: index === selected })}
                                    onClick={() => {
                                        setSelected(index);
                                        setStep(0);
                                    }}
                                >
                                    {p.topic}
                                </Box>
                            )
                        })}
                    </Box>
                    <Box>
                        <Grid container spacing={4}>
                            <Grid item xs={7}>
                                <Box sx={boxImage}>
                                    <img src={ListGuide[selected].steps[step].image} alt="img" />
                                </Box>
                            </Grid>
                            <Grid item xs={5}>
                                <Stepper activeStep={step} orientation="vertical">
                                    {ListGuide[selected].steps.map((p, index) => {
                                        return (
                                            <Step key={index} completed={false} className={clsx({ [classes.stepActive]: step === index })}>
                                                <StepButton
                                                    onClick={() => setStep(index)}
                                                    disabled={false}
                                                    className={clsx({ [classes.stepActive]: step === index })}
                                                    sx={{
                                                        cursor: "pointer",
                                                        '& .MuiStepLabel-root': {
                                                            cursor: 'pointer'
                                                        },
                                                        fontFamily: "'Asap', normal",
                                                    }}
                                                >
                                                    {p.title}
                                                </StepButton>
                                                <StepContent>
                                                    <Typography sx={content}>{p.content}</Typography>
                                                </StepContent>
                                            </Step>
                                        )
                                    })}
                                </Stepper>
                            </Grid>
                        </Grid>
                    </Box>
                </Container>
            </Container>
        </Box>
    )
}

const useStyles = makeStyles({
    topic: {
        cursor: 'pointer',
        height: '3.5rem',
        fontWeight: '600',
        textAlign: 'center',
        padding: '0 1.9rem',
        border: '1px solid',
        borderRadius: '4rem',
        display: 'flex',
        alignItems: 'center',
        color: Color.Normal,
        '&:hover': {
            backgroundColor: Color.Active,
            color: '#fff'
        }
    },
    topicSelected: {
        backgroundColor: Color.Active,
        color: '#fff'
    },
    stepActive: {
        color: Color.Active,
        '& .MuiStepIcon-root.Mui-active': {
            color: '#FF37A5 !important'
        },
        '& .MuiStepLabel-label.Mui-active': {
            color: '#FF37A5 !important'
        }
    }
});